import ls from "../services/localStorage";
import { types } from "../constants/constants";

export const getApiBooks = (attributes : any): Promise<object> => {
  const esc = encodeURIComponent;
  const query = Object.keys(attributes) ? '?' + Object.keys(attributes).map(k => `${esc(k)}=${esc(attributes[k])}`).join('&') : ''
  const token:(string | null) = ls.get("token");
  
  return fetch(`${types.API_URL}books${query}`, { 
    headers : { token : ( token !== null ? token : '') } 
  }).then(async (response) => {
    if(!response.ok){
      const responseJson = await response.json()
      throw new Error(responseJson)
    }
    const result: object = await response.json()

    return result;
  })
};

export const getApiBook = (attributes : any): Promise<object> => {
  const esc = encodeURIComponent;
  const query = Object.keys(attributes) ? '?' + Object.keys(attributes).map(k => `${esc(k)}=${esc(attributes[k])}`).join('&') : ''
  const token:(string | null) = ls.get("token");
  
  return fetch(`${types.API_URL}books/id/${attributes._id}`, { 
    headers : { token : ( token !== null ? token : '') } 
  }).then(async (response) => {
    if(!response.ok){
      const responseJson = await response.json()
      throw new Error(responseJson)
    }
    const result: object = await response.json()

    return result;
  })
};

export const putApiUpdateBook = (attributes: any) => {
  const token:(string | null) = ls.get("token");

  return fetch(`${types.API_URL}books/update-isbn/id/${attributes.book._id}`, {
    method: "PUT",
    headers: {
      token : ( token !== null ? token : ''),
      "Content-Type": "application/json",
    },
    body: JSON.stringify(attributes),
  }).then(async (response) => {
    if(!response.ok){
      const responseJson = await response.json()
      throw new Error(responseJson)
    }
    return response.json()
  }); 
};


export const getApiBooksActions = (attributes : any): Promise<object> => {
  const esc = encodeURIComponent;
  const query = Object.keys(attributes) ? '?' + Object.keys(attributes).map(k => `${esc(k)}=${esc(attributes[k])}`).join('&') : ''
  const token:(string | null) = ls.get("token");
  
  return fetch(`${types.API_URL}books/id/${attributes._id}/actions`, { 
    headers : { token : ( token !== null ? token : '') } 
  }).then(async (response) => {
    if(!response.ok){
      const responseJson = await response.json()
      throw new Error(responseJson)
    }
    const result: object = await response.json()

    return result;
  })
};